import { MetaResponse } from './common.interface';

export enum DocumentStatus {
	DRAFT = 'draft',
	FINALIZED = 'finalized',
	INACTIVE = 'inactive',
	DEPRECATED = 'deprecated',
}

export const DOCUMENT_STATUSES = [DocumentStatus.DRAFT, DocumentStatus.FINALIZED] as const;

export const [DRAFT_STATUS, FINALIZED_STATUS] = DOCUMENT_STATUSES;

export const TEMPLATE_TYPES = [
	'documents-health-pyme',
	'documents-life-pyme',
	'documents-health-codelco',
	'documents-life-codelco',
	'documents-health-nonpretariffed',
	'documents-life-nonpretariffed',
] as const;

export const POLICY_ID_PATTERN = /^\d+-\d+$/;

export type TemplateType = (typeof TEMPLATE_TYPES)[number];

export interface DocumentMetadata {
	policyId: string;
	policyNumber?: number;
	renewalNumber?: number;
	identifier?: string;
	personCode?: number;
}

export interface PolicyDocument {
	id: string;
	type: string;
	version: number;
	status: DocumentStatus;
	file: string;
	metadata: DocumentMetadata;
	attributes?: Record<string, unknown>;
	documentType?: string;
	createdAt?: string;
	updatedAt?: string;
}

export interface DocumentListItem {
	id: string;
	policyId: string | null;
	type: string;
	version: number;
	status: DocumentStatus;
	date: string | null;
}

/** One version of a policy document as returned by the versions endpoint, newest first. */
export type DocumentVersion = Pick<
	PolicyDocument,
	'id' | 'type' | 'version' | 'status' | 'metadata' | 'createdAt' | 'updatedAt'
> & {
	rejectionHistory?: { description: string; revertedAt: string }[];
};

export interface DocumentListResult {
	items: DocumentListItem[];
	meta?: MetaResponse;
}

export interface DocumentListParams {
	policyId?: string;
	policyNumber?: string;
	type?: string;
	status?: string;
	page?: number;
}
